export default function OurStatatics(){
    return <>
        <div  className="ourStatatics" > 
                <div className="container" >
                    <ul>
                        <li>
                            <h2>15+</h2>
                            <p>Years in Business</p>
                        </li>
                        <li>
                            <h2>10m+</h2>
                            <p>Happy Clients Served</p>
                        </li>
                        <li>
                            <h2>2m+</h2>
                            <p>Trucks Deliverd till now</p>
                        </li>
                        <li>
                            <h2>1m+</h2>
                            <p>Five Star Rating</p>
                        </li>
                    </ul>
                </div>
        </div>
    </>
}